export const NEW_QUESTION = 'QUESTION_NEW';
export const REMOVE_QUESTION = 'QUESTION_REMOVE';
export const UPDATE_QUESTION = 'QUESTION_UPDATE';
export const SET_ERRORS = 'PAPERS_SET_ERRORS';

export function setErrors(errors, elementId) {
    return {
        type: SET_ERRORS,
        elementId,
        errors,
    };
};


export function updateQuestion(question, elementId) {
    return {
        type: UPDATE_QUESTION,
        elementId,
        payload: question,
    };
}

export function addQuestion(question, elementId) {
    return {
        type: NEW_QUESTION,
        elementId,
        payload: question,
    };
}

export function removeQuestion(id) {
    return {
        type: REMOVE_QUESTION,
        payload: id,
    };
}
